import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=b05adf10&scoped=true"
import script from "./ViewGroup.vue?vue&type=script&lang=js"
export * from "./ViewGroup.vue?vue&type=script&lang=js"
import style0 from "./ViewGroup.vue?vue&type=style&index=0&id=b05adf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05adf10",
  null
  
)

export default component.exports